/* eslint-disable no-console */
import { isProduction } from "./isProduction";

export const Log = (...message: unknown[]): void => {
  if (!isProduction()) {
    console.log(...message);
  }
};

export const Warn = (...message: unknown[]): void => {
  if (!isProduction()) {
    console.warn(...message);
  }
};

export const Error = (...message: unknown[]): void => {
  if (!isProduction()) {
    console.error(...message);
    // TODO: show message in snackbar
  }
};
